export const APP_URL = process.env.RAILS_API_ENDPOINT;

export const ENTRIES_ENDPOINT = `${APP_URL}/entries`;
export const CSV_ENDPOINT = `${APP_URL}/csv`;
export const LAST_CSV_ENDPOINT = `${APP_URL}/last_csv`;
export const DIVISIONS_ENDPOINT = `${APP_URL}/divisions`;
export const VENDORS_ENDPOINT = `${APP_URL}/vendors`;
export const EXPENSE_ACCOUNTS_ENDPOINT = `${APP_URL}/expense_accounts`;
export const AUTH_ENDPOINT = `${APP_URL}/auth`;
export const S3_ENDPOINT = 	process.env.S3_URL;
export const WEEKLY_ENTRIES_ENDPOINT = `${APP_URL}/daily_entries`;
export const MOST_RECENT_DOWNLOAD_TIME = `${APP_URL}/last_report`;



// WEBPACK FOOTER //
// ./src/api/api.js